import Game from "Game";
import { IGameState } from "State/Game/IGameState";
import System from "../System";
import preloadEvents from "./EventSystemHelper";

export default class EventSystem extends System {

    public async preload() {
        const state = Game.store.getState();

        preloadEvents(state);
    }

    public handleStateChanged(state: IGameState): void {}
    public init(params?: any): void {}
    protected onUpdate(): void {}
    protected onLateUpdate(): void {}
    public onStart(): void {}
    protected onStop(): void {}
    protected onDestroy(): void {}
    
}